<template lang="html">
  <div class="detail">
    <common-header></common-header>
    <div class="page">
      <div class="wrapper-content container">
        <div class="ibox-title ">
          <h5 class="text-center">会员资料</h5>
        </div>
        <div class="box">
          <form>
            <div class="row border-bottom">
              <div class="col-sm-3">
                <div class="card" style="border:none;">
                  <div class="border" :class="!formData1.photo ? 'minHeight' : ''">
                    <img class="card-img-top" :src="formData1.photo">
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red"></span>姓名：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.name }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">笔名/艺名：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.penname }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters" v-if="formData1.gender != -1">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red"></span>性别：</label>
                  <div class="col-sm-8 alignCenter">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" disabled
                        :checked="formData1.gender == 1">
                      <label class="form-check-label" for="inlineRadio1">男</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" disabled
                        :checked="formData1.gender == 0">
                      <label class="form-check-label" for="inlineRadio2">女</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red"></span>出生日期：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.birthdate }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red"></span>民族：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.nation }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red"></span>政治面貌：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.political }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red"></span>文化程度：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.education }}</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red"></span>籍贯：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.birthplace }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">工作单位：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.employer }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label overflowAuto">职务：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.position }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">职称：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.positiontitle }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red"></span>身份证号：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.idnumber }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">申请协会：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.union }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">会员编号：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.memberid }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row part border-bottom">
              <div class="col-sm-5">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label"><span class="red"></span>通讯地址：</label>
                  <div class="col-sm-8 ">
                    <span class="form-span address">{{ formData1.address }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">邮编：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.postcode }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">办公电话：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.officephone }}</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-5 offset-sm-2">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">家庭电话：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.telephone }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">电子邮箱：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.email }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">微信号：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.wechat }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3   col-form-label"><span class="red"></span>手机号：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.mobile }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row part border-bottom">
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">国家级会员：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ checkTime(formData1.joindate_n) }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">省级会员：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ checkTime(formData1.joindate_p) }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">市级会员：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ checkTime(formData1.joindate_c) }}</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">会员证编号：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.mid_n }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">会员证编号：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.mid_p }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">会员证编号：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.mid_c }}</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">协会职务：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.posi_n }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">协会职务：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.posi_p }}</span>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">协会职务：</label>
                  <div class="col-sm-8">
                    <span class="form-span">{{ formData1.posi_c }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row part step2" v-if="formData2.awards && formData2.awards.length">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12">
                    <h5 class="sub-tit">主要艺术成就及获奖情况：</h5>
                  </div>
                  <div class="col-sm-12">
                    <div class="border" style="overflow-x: auto;">
                      <table class="table">
                        <thead class="">
                          <tr scope="row">
                            <th class="text-center" scope="col">时间</th>
                            <th class="text-center" scope="col">地点</th>
                            <th class="text-center" scope="col">主办单位</th>
                            <th class="text-center" scope="col">著作出版社</th>
                            <th class="text-center" scope="col">作品或获奖情况</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="text-center border-bottom" v-for="(item, index) in formData2.awards">
                            <td>{{ item.date }}</td>
                            <td>{{ item.place }}</td>
                            <td>{{ item.organizer }}</td>
                            <td>{{ item.press }}</td>
                            <td>{{ item.awards }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="row col-sm-12 upload-image">
                    <div class="col-sm-auto" v-if="formData2.photos && formData2.photos.length"
                      v-for="(item, index) in formData2.photos">
                      <div class="example-img">
                        <el-image :src="item.path" :preview-src-list="[item.path]" style="height: 150px;"></el-image>

                      </div>
                    </div>
                    <!-- <div class="col-sm-2">
                      <div class="custom-file">
                        <input type="file" class="custom-file-input" id="customFile">
                        <label class="custom-file-label" for="customFile"></label>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row part step2 border-top" v-if="formData3 && formData3.length">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12">
                    <h5 class="sub-tit">主要经历：</h5>
                  </div>
                  <div class="col-sm-12">
                    <div class="border" style="overflow-x: auto;">
                      <table class="table">
                        <thead class="">
                          <tr scope="row">
                            <th class="text-center" scope="col">起始年月</th>
                            <th class="text-center" scope="col">结束年月</th>
                            <th class="text-center" scope="col">主要经历</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="text-center" v-for="item in formData3">
                            <td>{{ item.startdate }}</td>
                            <td>{{ item.enddate }}</td>
                            <td>{{ item.exp }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="form-group" style="margin: 0 auto;">
        <div class="btn btn-primary" @click="$router.push('/')">
          返回
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonHeader from './header.vue'
import stepSecond from './step2.vue'
import stepThird from './step3.vue'
import mapPicker from './map.vue'
export default {
  components: {
    commonHeader,
    mapPicker,
    stepSecond,
    stepThird,
  },
  data() {
    return {
      formData1: '',
      formData2: '',
      formData3: ''
    }
  },
  methods: {
    checkTime(time) {
      let date = new Date(time)
      if (date.getTime()) {
        return time
      } else {
        return ''
      }
    }
  },
  mounted() {
    let id = this.$route.query.id
    this.$axios.get('/api/wenlian/requestdetail', {
      params: {
        id: id,
        step: 1
      }
    }).then(res => {
      if (res.data.result == 1) {
        this.formData1 = res.data.data
      }
      // else {
      //   this.formData1 = { "id": "4359", "userid": "81", "name": "\u67f4\u4eac\u6b63", "pinyin": "chaijingzheng", "penname": "\u7af9\u5f71\u62c2\u5c18", "gender": "1", "birthdate": "1971-11-01", "nation": "\u6c49\u65cf", "political": "\u4e2d\u56fd\u5171\u4ea7\u515a\u515a\u5458", "education": "\u5927\u5b66\u672c\u79d1", "birthplace": "\u5c71\u4e1c\u7701\u9752\u5c9b\u5e02\u897f\u6d77\u5cb8\u65b0\u533a\u5b9d\u5c71\u9547\u4e0b\u67f4\u6751", "employer": "\u9752\u5c9b\u5e02\u897f\u6d77\u5cb8\u65b0\u533a\u7b2c\u4e09\u9ad8\u7ea7\u4e2d\u5b66", "position": "\u6559\u5e08", "positiontitle": "\u4e2d\u5b66\u9ad8\u7ea7\u6559\u5e08", "idnumber": "370223197111295333", "union": "\u9752\u5c9b\u5e02\u4f5c\u5bb6\u534f\u4f1a", "address": "\u5c71\u4e1c\u7701\u9752\u5c9b\u5e02\u897f\u6d77\u5cb8\u65b0\u533a\u7b2c\u4e09\u9ad8\u7ea7\u4e2d\u5b66", "telephone": "\u65e0", "email": "249707981@qq.com", "postcode": "266425", "wechat": "A15154281023", "officephone": "\u65e0", "mobile": "15154281023", "joindate_n": "", "joindate_p": "", "joindate_c": "", "mid_n": "", "mid_p": "", "mid_c": "", "posi_n": "", "posi_p": "", "posi_c": "", "photo": "", "intime": "2020-09-30 08:29:11", "status": "\u5f85\u5ba1\u6838", "memberid": "", "isdeleted": "0", "remark": "\u5165\u4f1a\u8981\u6c42\u5728\u5e02\u7ea7\u4ee5\u4e0a\u62a5\u520a\u6742\u5fd7\u53d1\u8868\u6587\u5b66\u4f5c\u54c1\u4e24\u7bc7\u4ee5\u4e0a\u6216\u8005\u83b7\u5f97\u5e02\u7ea7\u4ee5\u4e0a\u6587\u5b66\u5956\u9879\u3002" }
      // }
    })
    this.$axios.get('/api/wenlian/requestdetail', {
      params: {
        id: id,
        step: 2
      }
    }).then(res => {
      if (res.data.result == 1) {
        this.formData2 = res.data.data
      }
      // else {
      //   this.formData2 = { "awards": [{ "id": "125", "mid": "4359", "date": "2020-03", "place": "\u70df\u53f0\u5e02", "organizer": "\u5c71\u4e1c\u6563\u6587\u5b66\u4f1a", "press": "\u80f6\u4e1c\u6563\u6587\u5341\u4e8c\u5bb6\uff08\u7b2c\u4e09\u8f91\uff09", "awards": "\u53d1\u8868\u6563\u6587\u516d\u7bc7\uff0c\u83b72020\u5e74\u5ea6\u80f6\u4e1c\u6563\u6587\u4f18\u79c0\u4f5c\u54c1\u5956" }, { "id": "126", "mid": "4359", "date": "2020-05", "place": "\u70df\u53f0\u5e02", "organizer": "\u5c71\u4e1c\u6563\u6587\u5b66\u4f1a", "press": "\u80f6\u4e1c\u6563\u6587\u5e74\u9009", "awards": "\u53d1\u8868\u300a\u4e2d\u5e74\u4e4b\u60d1\u300b" }, { "id": "127", "mid": "4359", "date": "2012-11", "place": "\u897f\u6d77\u5cb8\u65b0\u533a", "organizer": "\u4e2d\u56fd\u6821\u5916\u6559\u80b2\u6742\u5fd7\u793e\u7f16\u8f91\u90e8", "press": "\u300a\u4e2d\u56fd\u6821\u5916\u6559\u80b2\u300b\u6742\u5fd7", "awards": "\u53d1\u8868\u300a\u6d45\u8c08\u5fb7\u80b2\u6559\u80b2\u7684\u5b9e\u65bd\u9014\u5f84\u300b" }, { "id": "695", "mid": "4359", "date": "2020-11", "place": "", "organizer": "", "press": "", "awards": "" }], "photos": [{ "id": "3645", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153429_680.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3646", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153552_581.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3647", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153558_531.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3648", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153609_993.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3649", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153618_471.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3650", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153625_707.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3651", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153642_880.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3652", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153649_337.jpg", "intime": "2021-09-23 15:38:17", "desc": null }, { "id": "3653", "mid": "4359", "path": "http:\/\/res2.shiminjia.com\/wenlian\/202109\/23\/153703_718.jpg", "intime": "2021-09-23 15:38:17", "desc": null }] }
      // }
    })
    this.$axios.get('/api/wenlian/requestdetail', {
      params: {
        id: id,
        step: 3
      }
    }).then(res => {
      if (res.data.result == 1) {
        this.formData3 = res.data.data
      }
      // else {
      //   this.formData3 = [{ "id": "119", "mid": "4359", "startdate": "1993-07", "enddate": "", "exp": "\u9752\u5c9b\u5e02\u897f\u6d77\u5cb8\u65b0\u533a\u7b2c\u4e09\u9ad8\u7ea7\u4e2d\u5b66  \u4efb\u6559\u9ad8\u4e2d\u8bed\u6587" }]
      // }
    })
  }
}
</script>

<style lang="css" scoped>
.detail .btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show>.btn-primary.dropdown-toggle {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}

.detail .btn-primary {
  background-color: #18a689;
  border-color: #18a689;
  width: 200px;
}

.detail .btn-primary:hover {
  background-color: #1ab394;
  border-color: #1ab394;
}

.detail .btn-primary.disabled {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}

.detail .part {
  padding: 20px 0;
}

.detail .border {
  width: 100%;
  position: relative;
  min-height: 360px;
  overflow: hidden;
}

.detail .border::after {
  content: "照片";
  position: absolute;
  color: #999;
  font-size: 14px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.detail .minHeight {
  min-height: 360px;
}

.detail .border img {
  z-index: 11;
  position: relative;
}

.detail .fullScreen {
  height: 100%;
}

.detail .page-link {
  color: #33434b;
}

.detail .page-link:hover {
  background: #f4f4f4;
  color: #33434b;
}

.detail .page-link.active {
  background: #f4f4f4;
}

.detail .custom-file-label::after {
  content: "上传照片";
  border-radius: 0.25rem;
  text-align: center;
  width: 100%;
  height: 100%;
}

.detail .custom-file-label {
  border: none;
}

.detail .red {
  color: red;
  margin: 0 5px;
}

.detail .form-group label {
  font-size: 15px;
  color: #33434b;
}

.detail input,
.detail select,
.detail option,
.detail .textarea,
.detail .form-check label {
  color: #33434b;
  font-size: 15px;
}

.detail .step2 .custom-file-label::after {
  content: "证明材料上传";
  border-radius: 0.25rem;
  text-align: center;
  width: 100%;
  height: 100%;
}

.detail .step2 .custom-file-label {
  border: none;
}

.detail .step2 .red {
  color: red;
  margin: 0 5px;
}

.detail .step2 .sub-tit {
  color: #33434b;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 15px;
}

.detail .step2 table td,
table th {
  color: #333;
}

.detail .step2 .table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: none;
}

.detail .step2 .form-group {
  margin-bottom: 0;
}

.detail .step2 .upload-image {
  margin-top: 20px;
}

.detail .step2 .upload-image img {
  height: 150px;
  width: auto;
}

.detail .step2 .custom-file {
  margin-top: 0%;
}

.detail .step2 .example-img {
  height: 150px;
  min-width: 150px;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  position: relative;
}

.detail .step2 .example-img:after {
  content: "+";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #33434b;
  font-size: 50px;
}

.detail .step2 .border {
  min-height: auto;
}

.detail .step2 .border::after {
  content: "";
}

.detail .sub-tit {
  color: #33434b;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 15px;
}

.detail textarea {
  min-height: 200px;
}

.detail .form-span {
  line-height: 1.5;
  color: #33434b;
  font-size: 15px;
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #33434b;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  overflow-y: auto;
  white-space: nowrap;
}

.detail table {
  margin-bottom: 0;
}

.form-span.address {
  height: auto !important;
  white-space: normal;
}

.overflowAuto {
  overflow: auto;
}

@media screen and (max-width: 750px) {
  .col-form-label {
    text-align: left;
  }

  .detail .step2 .example-img:after {
    z-index: -1;
  }

  .table {
    width: 1400px;
    animation: scroll 1s ease-in-out 0.5s;
  }

  .detail .step2 .upload-image {
    text-align: center;
  }

  .detail .step2 .upload-image .col-sm-auto {
    margin-bottom: 20px;
  }

  .detail .step2 .upload-image img {
    width: 100%;
    object-fit: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail.vue